/**
 * `/team/performance` route — gated on `appraisal:review:read:team` per be-063.
 * Renders the live <TeamPerformanceScreen> list view (Phase 08.2, D-16).
 */
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { TeamPerformanceScreen } from "../features/team/TeamPerformanceScreen.js";

export const Route = createFileRoute("/_auth/team/performance")({
  staticData: { breadcrumb: { labelKey: "team:nav.performance" } },
  beforeLoad: requirePermission({
    anyOf: ["appraisal:review:read:team"],
    defaultRoute: "/me/overview",
  }),
  component: TeamPerformanceScreen,
});
